import React from 'react';
import styles from './CallsInfoSkeleton.module.scss';
import cn from 'classnames';

const CallsInfoSkeleton = ({ className, style }) => {
  return (
    <div className={cn(styles.callsInfoSkeleton, className)} style={style}>
      <div className={styles.secondsInfo}>
        <div className={styles.title} />
        <div className={styles.content} />
        <div className={styles.footer} />
      </div>
      <div className={styles.circleContainer}>
        <div className={styles.circle} />
      </div>
      <div className={styles.legend}>
        {[1, 2, 3].map((item) => (
          <div key={item} className={styles.legendItem}>
            <div className={styles.smallCircle} />
            <div className={styles.legendText} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default CallsInfoSkeleton;
